"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
const runtime_1 = require("@zenstackhq/runtime");
function User_update(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (user == null) ? { OR: [] } : {
        id: user.id
    };
}
function User_delete(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (user == null) ? { OR: [] } : {
        id: user.id
    };
}
function User$email_read(input, context) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (((0, runtime_1.allFieldsEqual)(user, input, ['id']) || ((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null)));
}
function User$name_read(input, context) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (((0, runtime_1.allFieldsEqual)(user, input, ['id']) || ((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null)));
}
function User$email_update(context, db) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [(user == null) ? { OR: [] } : {
                id: user.id
            }, !!((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null) ? { AND: [] } : { OR: [] }]
    };
}
function User$name_update(context, db) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [(user == null) ? { OR: [] } : {
                id: user.id
            }, !!((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null) ? { AND: [] } : { OR: [] }]
    };
}
function Spot_update(context, db) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [{
                OR: [{
                        OR: [(user == null) ? { OR: [] } : {
                                user: {
                                    is: {
                                        id: user.id
                                    }
                                }
                            }, (user == null) ? { OR: [] } : {
                                list: {
                                    user: {
                                        is: {
                                            id: user.id
                                        }
                                    }
                                }
                            }]
                    }, {
                        list: {
                            collaborators: {
                                some: (user == null) ? { OR: [] } : {
                                    user: {
                                        is: {
                                            id: user.id
                                        }
                                    }
                                }
                            }
                        }
                    }]
            }, !!((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null) ? { AND: [] } : { OR: [] }]
    };
}
function Spot_delete(context, db) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [{
                OR: [{
                        OR: [(user == null) ? { OR: [] } : {
                                user: {
                                    is: {
                                        id: user.id
                                    }
                                }
                            }, (user == null) ? { OR: [] } : {
                                list: {
                                    user: {
                                        is: {
                                            id: user.id
                                        }
                                    }
                                }
                            }]
                    }, {
                        list: {
                            collaborators: {
                                some: (user == null) ? { OR: [] } : {
                                    user: {
                                        is: {
                                            id: user.id
                                        }
                                    }
                                }
                            }
                        }
                    }]
            }, !!((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null) ? { AND: [] } : { OR: [] }]
    };
}
function SpotImage_update(context, db) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [{
                OR: [(user == null) ? { OR: [] } : {
                        spot: {
                            list: {
                                user: {
                                    is: {
                                        id: user.id
                                    }
                                }
                            }
                        }
                    }, {
                        spot: {
                            list: {
                                collaborators: {
                                    some: (user == null) ? { OR: [] } : {
                                        user: {
                                            is: {
                                                id: user.id
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }]
            }, !!((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null) ? { AND: [] } : { OR: [] }]
    };
}
function SpotImage_delete(context, db) {
    var _a, _b;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [{
                OR: [(user == null) ? { OR: [] } : {
                        spot: {
                            list: {
                                user: {
                                    is: {
                                        id: user.id
                                    }
                                }
                            }
                        }
                    }, {
                        spot: {
                            list: {
                                collaborators: {
                                    some: (user == null) ? { OR: [] } : {
                                        user: {
                                            is: {
                                                id: user.id
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }]
            }, !!((_b = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _b !== void 0 ? _b : null) ? { AND: [] } : { OR: [] }]
    };
}
function UserSpotVisit_update(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [(user == null) ? { OR: [] } : {
                user: {
                    is: {
                        id: user.id
                    }
                }
            }, (user == null) ? { OR: [] } : {
                spot: {
                    user: {
                        is: {
                            id: user.id
                        }
                    }
                }
            }]
    };
}
function UserSpotVisit_read(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [(user == null) ? { OR: [] } : {
                user: {
                    is: {
                        id: user.id
                    }
                }
            }, (user == null) ? { OR: [] } : {
                spot: {
                    user: {
                        is: {
                            id: user.id
                        }
                    }
                }
            }]
    };
}
function UserSpotVisit_delete(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return {
        OR: [(user == null) ? { OR: [] } : {
                user: {
                    is: {
                        id: user.id
                    }
                }
            }, (user == null) ? { OR: [] } : {
                spot: {
                    user: {
                        is: {
                            id: user.id
                        }
                    }
                }
            }]
    };
}
function UserSpotFav_update(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (user == null) ? { OR: [] } : {
        user: {
            is: {
                id: user.id
            }
        }
    };
}
function UserSpotFav_delete(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (user == null) ? { OR: [] } : {
        user: {
            is: {
                id: user.id
            }
        }
    };
}
function UserPlaceSave_update(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (user == null) ? { OR: [] } : {
        user: {
            is: {
                id: user.id
            }
        }
    };
}
function UserPlaceSave_delete(context, db) {
    var _a;
    const user = (_a = context.user) !== null && _a !== void 0 ? _a : null;
    return (user == null) ? { OR: [] } : {
        user: {
            is: {
                id: user.id
            }
        }
    };
}
const policy = {
    guard: {
        user: {
            create: true, create_input: true, update: User_update, postUpdate: true, read: true, delete: User_delete, readFieldCheck$email: User$email_read, readFieldCheck$name: User$name_read, hasFieldLevelPolicy: true, readFieldSelect: { "id": true }, updateFieldGuard$email: User$email_update, updateFieldGuard$name: User$name_update,
        }, account: {
            create: false, create_input: false, update: false, postUpdate: true, read: false, delete: false,
        }, session: {
            create: false, create_input: false, update: false, postUpdate: true, read: false, delete: false,
        }, verificationToken: {
            create: false, create_input: false, update: false, postUpdate: true, read: false, delete: false,
        }, place: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, placeAffiliate: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, googleImage: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, list: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, listTag: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, tag: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, sharedUsersOnLists: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, followersOnLists: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, collaboratorsOnLists: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, spot: {
            create: true, create_input: true, update: Spot_update, postUpdate: true, read: true, delete: Spot_delete,
        }, spotImage: {
            create: true, create_input: true, update: SpotImage_update, postUpdate: true, read: true, delete: SpotImage_delete,
        }, spotTag: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, userSpotVisit: {
            create: true, create_input: true, update: UserSpotVisit_update, postUpdate: true, read: UserSpotVisit_read, delete: UserSpotVisit_delete,
        }, userSpotFav: {
            create: true, create_input: true, update: UserSpotFav_update, postUpdate: true, read: true, delete: UserSpotFav_delete,
        }, userPlaceSave: {
            create: true, create_input: true, update: UserPlaceSave_update, postUpdate: true, read: true, delete: UserPlaceSave_delete,
        }, trip: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, tripDay: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, tripItem: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, popularPlan: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, inquiry: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, experience: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, experienceImage: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, experiencePlace: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, bookingExperience: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        }, save: {
            create: true, create_input: true, update: true, postUpdate: true, read: true, delete: true,
        },
    },
    validation: {
        user: {
            hasValidation: false
        },
        account: {
            hasValidation: false
        },
        session: {
            hasValidation: false
        },
        verificationToken: {
            hasValidation: false
        },
        place: {
            hasValidation: false
        },
        placeAffiliate: {
            hasValidation: false
        },
        googleImage: {
            hasValidation: false
        },
        list: {
            hasValidation: false
        },
        listTag: {
            hasValidation: false
        },
        tag: {
            hasValidation: false
        },
        sharedUsersOnLists: {
            hasValidation: false
        },
        followersOnLists: {
            hasValidation: false
        },
        collaboratorsOnLists: {
            hasValidation: false
        },
        spot: {
            hasValidation: false
        },
        spotImage: {
            hasValidation: false
        },
        spotTag: {
            hasValidation: false
        },
        userSpotVisit: {
            hasValidation: false
        },
        userSpotFav: {
            hasValidation: false
        },
        userPlaceSave: {
            hasValidation: false
        },
        trip: {
            hasValidation: false
        },
        tripDay: {
            hasValidation: false
        },
        tripItem: {
            hasValidation: false
        },
        popularPlan: {
            hasValidation: false
        },
        inquiry: {
            hasValidation: false
        },
        experience: {
            hasValidation: false
        },
        experienceImage: {
            hasValidation: false
        },
        experiencePlace: {
            hasValidation: false
        },
        bookingExperience: {
            hasValidation: false
        },
        save: {
            hasValidation: false
        },
    },
    authSelector: { "isAdmin": true }
};
exports.default = policy;
